/*
 * Copyright (c) 2018 DV Bern AG, Switzerland
 *
 * Das vorliegende Dokument, einschliesslich aller seiner Teile, ist urheberrechtlich
 * geschuetzt. Jede Verwertung ist ohne Zustimmung der DV Bern AG unzulaessig. Dies gilt
 * insbesondere fuer Vervielfaeltigungen, die Einspeicherung und Verarbeitung in
 * elektronischer Form. Wird das Dokument einem Kunden im Rahmen der Projektarbeit zur
 * Ansicht uebergeben ist jede weitere Verteilung durch den Kunden an Dritte untersagt.
 *
 */

export enum TSVersicherungsbeitragStatus {
    NEU = <any> 'NEU',

    IN_BEARBEITUNG_FS = <any> 'IN_BEARBEITUNG_FS',
    AUSZAHLUNG = <any> 'AUSZAHLUNG',
    ABGESCHLOSSEN = <any> 'ABGESCHLOSSEN',
    ABGELEHNT_FONDSSUISSE = <any> 'ABGELEHNT_FONDSSUISSE'
}

export function getTSVersicherungsbeitragStatusalues(): Array<TSVersicherungsbeitragStatus> {
    return [
        TSVersicherungsbeitragStatus.NEU,

        TSVersicherungsbeitragStatus.IN_BEARBEITUNG_FS,

        TSVersicherungsbeitragStatus.AUSZAHLUNG,
        TSVersicherungsbeitragStatus.ABGESCHLOSSEN,
        TSVersicherungsbeitragStatus.ABGELEHNT_FONDSSUISSE,
    ];
}

export function getTSVersicherungsbeitragStatusInBearbeitung(): Array<TSVersicherungsbeitragStatus> {
    return [
        TSVersicherungsbeitragStatus.NEU,
        TSVersicherungsbeitragStatus.IN_BEARBEITUNG_FS,
    ];
}

/**
 * Returns true when the status of the Gesuch is Geschlossen
 * @returns {boolean}
 */
export function isStatusInBearbeitung(status: TSVersicherungsbeitragStatus): boolean {
    return isInStatus(status, getTSVersicherungsbeitragStatusInBearbeitung());
}

export function isInStatus(status: TSVersicherungsbeitragStatus, statusArray: Array<TSVersicherungsbeitragStatus>): boolean {
    for (let istatus of statusArray) {
        if (istatus === status) {
            return true;
        }
    }
    return false;
}






// WEBPACK FOOTER //
// ./src/app/models/enums/TSVersicherungsbeitragStatus.ts